import { SelectionChangedEvent } from "ag-grid-community";
import { CompanyEmptyPoolEntity } from "domain/entity/Company/CompanyEmptyPoolEntity";
import _ from "lodash";
import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CompanyConstant } from "presentation/constant/Company/CompanyConstant";
import { INITIAL_COMPANY_EMPTY_POOL_COL_DEF, INITIAL_COMPANY_EMPTY_POOL_COL_DEF_OICT, transferRowData } from "presentation/constant/Company/CompanyEmptyPoolColumnDefinition";
import { useCompanyEmptyPoolVM } from "presentation/hook/Company/useCompanyEmptyPoolVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const CompanyEmptyPoolTablePanel: React.FC = () => {
    const [companyDetailState] = useCompanyDetailTracked();
    const [anainfoState] = useANAInfoTracked();
    const companyEmptyPoolVM = useCompanyEmptyPoolVM();
    const messageBarVM = useMessageBarVM();

    const rightClickRef: any = createRef();
    const { allowUpdate, allowCreate, allowDelete } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const { companyId } = companyDetailState;
    const COMPANY_DTL_CONST = CompanyConstant.Detail;
    const { isAdd, isEditable, isEditCompDtlInfo, isShowFsp, isShowEmptyPool, isShowSuppleTerms, isShowCustAssign,
        isShowCustInfo, isShowFactor, isShowFspBulkEdit } = companyDetailState.viewState;
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const { selectedDatas } = companyDetailState.companyEmptyPoolState
    let gridRef: any = useRef();

    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<CompanyEmptyPoolEntity[]>([]);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    //const isReadReject = isPermissionExist(Permission.COMPANY_EMPTY_POOL_REJECT, AclType.READ, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateReject = isPermissionExist(Permission.COMPANY_EMPTY_POOL_REJECT, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    //const isReadApprove = isPermissionExist(Permission.COMPANY_EMPTY_POOL_APPROVE, AclType.READ, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateApprove = isPermissionExist(Permission.COMPANY_EMPTY_POOL_APPROVE, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);

    const { operatingUnit } = anainfoState;

    useEffect(() => {
        if (isEditCompDtlInfo) {
            const handleRightClickMenu = (event: any) => {
                if (_.isEmpty(selectedDatas) || !allowUpdate) {
                    return;
                }
                event.preventDefault();
                rightClickRef.current.show(event);
            };
            document.getElementById('compEmptyPoolTable')?.addEventListener("contextmenu", handleRightClickMenu);

            return () => {
                document.getElementById('compEmptyPoolTable')?.removeEventListener("contextmenu", handleRightClickMenu);
            };
        }
    }, [rightClickRef, allowUpdate, selectedDatas, isEditCompDtlInfo]);

    const memoTableBtns = useMemo(() => {
        const tableBtns = [];

        tableBtns.push({
            id: 'onRefreshButton',
            icon: 'Icon-reload',
            title: 'Refresh'
        })

        /*if (isEditCompDtlInfo) {
            if (!(isAdd || isEditable)) {*/
        if (allowDelete) {
            tableBtns.push({
                id: 'onDeleteButton',
                icon: 'Icon-trash',
                title: 'Delete',
                disable: !(isEditCompDtlInfo/* && !(isAdd || isEditable)*/)
            })
        }

        if (allowCreate) {
            tableBtns.push({
                id: 'onAddButton',
                icon: 'Icon-add',
                title: 'Add',
                disable: !(isEditCompDtlInfo/* && !(isAdd || isEditable)*/)
            })
        }
        /*    }
        }*/

        return tableBtns
    }, [isEditCompDtlInfo, allowDelete, allowCreate])

    const handleAddClick = useCallback(async () => {
        companyEmptyPoolVM.onAdd();
    }, [companyEmptyPoolVM])

    const handleRefresh = useCallback(() => {
        setIsLoading(true);
        companyDetailState.companyId && companyEmptyPoolVM.initialEmptyPoolTableData(companyDetailState.companyId).then(() => {
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false)
        })
    }, [companyDetailState.companyId, companyEmptyPoolVM]);

    const handleDelete = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to delete.");
            return;
        }

        const isAllowDelete = !(selectedDatas?.find(selectedData => (selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED")));
        if (!isAllowDelete) {
            messageBarVM.showError("Record status is PROPOSED/FINALIZED, cannot delete.");
            return;
        }

        companyEmptyPoolVM.handleDelete();
    }, [companyEmptyPoolVM, messageBarVM, selectedDatas]);

    // let performedClicks = 0;
    const handleSelectionChange = useCallback((e: SelectionChangedEvent, delay: number = 250) => {
        if (isAdd) return;

        const selectedRows = e.api.getSelectedRows();
        companyEmptyPoolVM.onSelectedCompEmptyPools(selectedRows);
    }, [companyEmptyPoolVM, isAdd])

    const handleRowDoubleClick = useCallback((entity: CompanyEmptyPoolEntity) => {
        companyEmptyPoolVM.onEmptyPoolRowDoubleClick(entity);
    }, [companyEmptyPoolVM])

    const isDisableSubmit = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (selectedData.status === "FINALIZED"))) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const isDisableReject = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (
                !((selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED") && selectedData.confirmedDate === null))
            )) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const isDisableApprove = useCallback(() => {
        if (selectedDatas.length < 1
            || selectedDatas?.find(selectedData => (
                !((selectedData.status === "FINALIZED" || selectedData.status === "PROPOSED") && selectedData.confirmedDate === null))
            )) {
            return true;
        }

        return false;
    }, [selectedDatas]);

    const handleSubmit = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to submit.");
            return;
        }

        setIsLoading(true);
        companyEmptyPoolVM.onSubmit(selectedDatas).then(() => {
            companyDetailState.companyId && companyEmptyPoolVM.initialEmptyPoolTableData(companyDetailState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false)
            })
        }).catch((error) => {
            setIsLoading(false)
            messageBarVM.showError(error.message)
        })

    }, [companyDetailState.companyId, companyEmptyPoolVM, messageBarVM, selectedDatas]);

    const handleReject = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to reject.");
            return;
        }

        companyEmptyPoolVM.handleReject();
    }, [companyEmptyPoolVM, messageBarVM, selectedDatas]);

    const handleApprove = useCallback(() => {
        if (selectedDatas.length < 1) {
            messageBarVM.showError("Please select a record(s) to approve.");
            return;
        }

        setIsLoading(true);
        companyEmptyPoolVM.onApprove(selectedDatas).then(() => {
            companyDetailState.companyId && companyEmptyPoolVM.initialEmptyPoolTableData(companyDetailState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false)
            })
        }).catch((error) => {
            setIsLoading(false)
            messageBarVM.showError(error.message)
        })

    }, [companyDetailState.companyId, companyEmptyPoolVM, messageBarVM, selectedDatas]);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return selectedDatas;
    }, [selectedDatas]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        companyEmptyPoolVM.onSelectedCompEmptyPools([]);
        setShowMoveCursor(true);
    }, [companyEmptyPoolVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(companyDetailState.companyEmptyPools);
        companyEmptyPoolVM.onSelectedCompEmptyPools([]);
        setShowMoveCursor(false);
    }, [companyDetailState.companyEmptyPools, companyEmptyPoolVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        companyEmptyPoolVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                companyEmptyPoolVM.onSelectedCompEmptyPools([]);
                setShowMoveCursor(false);
            } else {
                companyEmptyPoolVM.initialEmptyPoolTableData(companyId).then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    companyEmptyPoolVM.onSelectedCompEmptyPools([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    companyEmptyPoolVM.onSelectedCompEmptyPools([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [companyEmptyPoolVM, companyId, messageBarVM]);

    const isRowSelectable = useCallback((params: any) => {
        if ((isShowEmptyPool && (isEditable || isAdd))
            || isShowFsp || isShowSuppleTerms || isShowCustAssign || isShowCustInfo || isShowFactor || isShowFspBulkEdit) {
            return false;
        } else {
            return true;
        }
    }, [isAdd, isEditable, isShowCustAssign, isShowCustInfo, isShowEmptyPool, isShowFactor, isShowFsp, isShowSuppleTerms, isShowFspBulkEdit]);

    const memoTableTitle = useMemo(() =>
        <Sidebarheader style={{ width: "100%", display: "flex", alignItems: "center" }}>
            <HeaderTitle>{COMPANY_DTL_CONST.EMPTY_POOL.EMPTY_POOL}</HeaderTitle>
            <StyledAction className="tm-animated-wrapper">
                {
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        {allowUpdate && <HPHButton label={'Submit'} size={'Small'} disabled={isDisableSubmit() || !isEditCompDtlInfo} theme={'Secondary'} onClick={handleSubmit} />}
                        {(isUpdateReject) && <HPHButton label={'Reject'} size={'Small'} disabled={isDisableReject()} theme={'Secondary'} onClick={handleReject} />}
                        {(isUpdateApprove) && <HPHButton label={'Approve'} size={'Small'} disabled={isDisableApprove()} theme={'Primary'} onClick={handleApprove} />}
                    </div>
                }
            </StyledAction>
        </Sidebarheader>
        , [COMPANY_DTL_CONST.EMPTY_POOL.EMPTY_POOL, handleApprove, handleReject, handleSubmit, isDisableApprove, isDisableReject, isDisableSubmit, isEditCompDtlInfo, isUpdateApprove, isUpdateReject, allowUpdate])

    const memoCompanyEmptyPoolTable = useMemo(() => {
        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="compEmptyPoolTable" style={{ marginTop: "50px" }}>
                    <NbisTable
                        id='company-empty-pool-table'
                        isNewColumnSetting={true}
                        columns={operatingUnit === 'SAPT' || operatingUnit === 'KICT' ? INITIAL_COMPANY_EMPTY_POOL_COL_DEF?.slice() : INITIAL_COMPANY_EMPTY_POOL_COL_DEF_OICT?.slice()}
                        data={transferRowData(allRows) ?? []}
                        headerActionButtons={memoTableBtns}
                        showPaginator={false}
                        editable={false}
                        showHeaderIcons={true}
                        showAddIcon={false}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        isRowHighligted={true}
                        selectionMode={true}
                        handleSelectionChanged={(e: any) => handleSelectionChange(e, 400)}
                        onRowDoubleClick={(e: any, row: CompanyEmptyPoolEntity) => handleRowDoubleClick(row)}
                        onAddButton={handleAddClick}
                        onRefreshButton={handleRefresh}
                        onDeleteButton={handleDelete}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 700px)"
                        ref={gridRef}
                        headerLabel={memoTableTitle}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        showCutCursor={showMoveCursor}
                        handleRowSelectable={isRowSelectable}
                        showPivotMode={false}
                    />
                </div>
            </>
        );
    }, [allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, operatingUnit, allRows, memoTableBtns, handleAddClick, handleRefresh, handleDelete, memoTableTitle, isRowSelectable, handleSelectionChange, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows) {
            setAllRows(companyDetailState.companyEmptyPools?.map((companyEmptyEntity, index) => ({
                ...companyEmptyEntity,
                index: index ?? 0,
                flag_showCutCursor: false
            })));
            setInitialAllRows(false);
        }
    }, [allRows, companyDetailState.companyEmptyPools, companyDetailState.companyFsps, initialAllRows]);

    useEffect(() => {
        setInitialAllRows(true);
    }, [companyDetailState.companyEmptyPoolState.forceRefresh]);

    // useEffect(() => {
    //     if (JSON.stringify(companyDetailState.companyEmptyPools?.map((companyEmptyEntity, index) => ({
    //         ...companyEmptyEntity,
    //         index: index ?? 0,
    //         flag_showCutCursor: false
    //     }))) !== JSON.stringify(allRows)) {
    //         setAllRows(companyDetailState.companyEmptyPools?.map((companyEmptyEntity, index) => ({
    //             ...companyEmptyEntity,
    //             index: index ?? 0,
    //             flag_showCutCursor: false
    //         })));
    //     }
    // }, [allRows, companyDetailState.companyEmptyPools]);

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            if (isShowFsp || isShowSuppleTerms || isShowCustAssign || isShowCustInfo || isShowFactor || isAdd || isShowFspBulkEdit) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isAdd, isEditable, isShowEmptyPool, isShowCustAssign, isShowCustInfo, isShowFactor, isShowFsp, isShowSuppleTerms, isShowFspBulkEdit])

    return <><TableWrapper>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {memoCompanyEmptyPoolTable}
    </TableWrapper>

    </>;
}

export default memo(CompanyEmptyPoolTablePanel);
